import React from "react";
import PropTypes from "prop-types";

// Styles
import colors from "core/colors";

// styles
import { TooltipWithMessageStyled, TextStyled } from "./styles";

// components
import Tooltip from "core/Tooltip";
import Info from "core/ReusableIcons/Info";

const TooltipWithMessage = ({ text, toolTipText }) => {
    return (
        <TooltipWithMessageStyled>
            <TextStyled>{text}</TextStyled>
            {toolTipText && (
                <Tooltip message={toolTipText} placement="top" clickToOpen>
                    <Info
                        fillColor={colors.accent.darkMode.suenosBuenos}
                        size={{ width: 16, height: 16 }}
                    />
                </Tooltip>
            )}
        </TooltipWithMessageStyled>
    );
};

export default TooltipWithMessage;

// prop-types
TooltipWithMessage.propTypes = {
    text: PropTypes.string,
    toolTipText: PropTypes.any
};
